import React, { useState } from "react";
import logo from "../assets/images/logo.png";
import facebookLogo from "../assets/icons/facebook-logo.png";
import googleLogo from "../assets/icons/Google-logo.png";
import { Link } from "react-router-dom";

const LogInPage = () => {
  const [isToggled, setToggled] = useState(false);

  const handleToggle = () => {
    setToggled(!isToggled);
  };
  return (
    <>
      <div className="flex flex-col h-screen w-full items-center">
        <img src={logo} alt="logo" className="w-[50%] logo" />
        {/* <div className="w-[50%] flex justify-end ">
          <div className="flex text-[12px] bg-[#F3F3F3] px-4 py-3 rounded-lg">
            <p className="mr-2">Sales Representative</p>

            <label className="blue-slider-toggle">
              <input
                type="checkbox"
                checked={isToggled}
                onChange={handleToggle}
              />
              <span className="slider"></span>
            </label>

            <p className="ml-2 text-[#2F80ED]">Admin</p>
          </div>
        </div> */}
        <div className="flex flex-col w-[50%] signup mt-16">
          <div className="text-[20px] text-[#2F80ED] mb-4">Welcome!</div>

          <div className="text-[14px] text-[#828282]">Email ID/Username</div>
          <input
            type="text"
            placeholder="Enter the email ID/username"
            className="border border-[#2F80ED] rounded-lg px-3 py-2 text-[16px] mb-1"
          />
          <div className="text-[14px] text-[#828282]">Password</div>
          <input
            type="password"
            placeholder="*********************"
            className="border border-[#2F80ED] rounded-lg px-3 py-2 text-[16px] mb-2"
          />

          <button className="border-none bg-[#2F80ED] py-[10px] text-white rounded-lg">
            <Link to={`${isToggled ? "/admin" : "/subscriptions"}`}>Login</Link>
          </button>
          <div className="flex flex-col items-center mt-4">
            <div className="text-[14px] mb-4">or login with</div>
            <div className="flex mb-4 justify-center ">
              <img src={facebookLogo} alt="facebook" className="w-9 mr-4" />
              <img src={googleLogo} alt="google" className="w-9 ml-4" />
            </div>
            <button className="text-[#2F80ED] underline text-[16px]">
              <Link to="/forgot-password">Forget Password</Link>
            </button>
          </div>
        </div>
        <div className=" mt-28 text-[16px]">
          Don't have an ClearResult account yet?{" "}
          <Link to="/signup">
            <span className="ml-1 text-[#2F80ED] cursor-pointer underline">
              Signup
            </span>
          </Link>
        </div>
      </div>
    </>
  );
};

export default LogInPage;
